import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import ReactResizeDetector from 'react-resize-detector'

import MainHeader from '../headers/MainHeader'
import ProductsViewPage from '../pages/ProductsViewPage'
import ProductsManagePage from '../pages/ProductsManagePage'
import LocationsViewPage from '../pages/LocationsViewPage'
import LocationsManagePage from '../pages/LocationsManagePage'
import InventoryPage from '../pages/InventoryPage'
import ControlListPage from '../pages/ControlListPage'
import ControlViewPage from '../pages/ControlViewPage'
import MaintenanceListPage from '../pages/MaintenanceListPage'
import MaintenanceViewPage from '../pages/MaintenanceViewPage'
import SpecialPage from '../pages/SpecialPage'
import SettingsPage from '../pages/SettingsPage'
import UsersPage from '../pages/UsersPage'
import AppConstants from '../../utils/AppConstants'

import './MainApp.css'

class MainApp extends React.Component {

  constructor(props) {

    // Properties
    super(props)

    // State
    this.state = {
      width: null,
      height: null
    }

    // Bind events
    this.onResizeWrapper = this.onResizeWrapper.bind(this)
  }

  onResizeWrapper(width, height) {
    this.setState({
      width,
      height
    })
  }

  render() {
    let page = null
    switch (this.props.page) {
      case AppConstants.PAGE.PRODUCTS_VIEW:
        page = (
          <ProductsViewPage />
        )
        break
      case AppConstants.PAGE.PRODUCTS_MANAGE:
        page = (
          <ProductsManagePage />
        )
        break
      case AppConstants.PAGE.LOCATIONS_VIEW:
        page = (
          <LocationsViewPage />
        )
        break
      case AppConstants.PAGE.LOCATIONS_MANAGE:
        page = (
          <LocationsManagePage />
        )
        break
      case AppConstants.PAGE.INVENTORY:
        page = (
          <InventoryPage />
        )
        break
      case AppConstants.PAGE.CONTROL_LIST:
        page = (
          <ControlListPage />
        )
        break
      case AppConstants.PAGE.CONTROL_VIEW:
        page = (
          <ControlViewPage />
        )
        break
      case AppConstants.PAGE.MAINTENANCE_LIST:
        page = (
          <MaintenanceListPage />
        )
        break
      case AppConstants.PAGE.MAINTENANCE_VIEW:
        page = (
          <MaintenanceViewPage />
        )
        break
      case AppConstants.PAGE.SPECIAL:
        page = (
          <SpecialPage />
        )
        break
      case AppConstants.PAGE.SETTINGS:
        page = (
          <SettingsPage />
        )
        break
      case AppConstants.PAGE.USERS:
        page = (
          <UsersPage />
        )
        break
      default:
        page = null
        break
    }
    return (
      <React.Fragment>
        <div
          className='main-container'
          style={{
            width: `${this.state.width}px`,
            height: `${this.state.height}px`
          }}
        >
          <div
            className='main-header'
          >
            <MainHeader />
          </div>
          <div
            className='main-body'
            style={{
              width: `${this.state.width}px`,
              height: `${this.state.height - 49}px`
            }}
          >
            {page}
          </div>
        </div>
        <ReactResizeDetector
          handleWidth
          handleHeight
          onResize={this.onResizeWrapper}
        />
      </React.Fragment>
    )
  }
}

MainApp.propTypes = {
  // Properties

  // Redux State
  page: PropTypes.string.isRequired

  // Redux Actions

}

export default connect(
  (state) => ({
    page: state.app.page
  }),
  (dispatch) => ({

  })
)(MainApp)



// WEBPACK FOOTER //
// ./src/containers/app/MainApp.js